import React, { useState } from 'react';
import Main from '../../component/Main.jsx';

const Sample = () => {
    return (
        <Main>
            <h2>Sample page</h2>
        </Main>
    )
}

export default Sample;